<template>
  <div v-if="storedProject" class="admin-page__content">
    <form>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h2 class="mb-0">
            {{ $t("vypisUzivatelu") }}
          </h2>
          {{ $t("proProjekt") }} {{ storedProject.projectName }}
        </div>
        <input
          id="guisearch"
          ref="searchInput"
          v-model="search"
          type="text"
          :placeholder="this.$t('hledat')"
          autofocus
        />
      </div>
    </form>
    <div class="mt-4">
      <div v-if="usersWithProjects.length > 0" class="position-relative w-100">
        <div id="users" class="table-responsive">
          <table class="table table-main table-hover">
            <thead>
              <tr>
                <th
                  v-for="(column, index) in columns"
                  :key="index"
                  :class="{ isHidden: !column.visible }"
                  :style="{ 'min-width': column.minWidth }"
                >
                  <span v-if="column.sortable !== true">
                    {{ $t(column.name) }}
                  </span>
                  <template v-else>
                    <div class="title" @click="sortBy(column.sortBy)">
                      {{ $t(column.name) }}
                    </div>
                    <div v-if="sort === column.type" class="sorting">
                      <span v-if="sortType === 'desc'">▼</span>
                      <span v-if="sortType === 'asc'">▲</span>
                    </div>
                  </template>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in filteredUserList.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td
                  v-for="(column, column_index) in columns"
                  :key="column_index"
                  :class="{
                    isHidden: !column.visible
                  }"
                  :style="{ width: column.minWidth }"
                >
                  <span v-if="column.name === 'userId'">
                    <a @click="openUserDetail(item)">
                      {{ item[column.type] }}
                    </a>
                  </span>
                  <span v-else-if="column.name === 'projects'" v-html="item[column.type].join(',')" />
                  <span v-else>
                    {{ item[column.type] }}
                  </span>
                </td>
                <td />
              </tr>
            </tbody>
          </table>
          <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
            <thead>
              <tr>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in filteredUserList.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td>
                  <div
                    id="kebab"
                    ref="kebab"
                    :class="{
                      opened: openedItem.userId === item.userId
                    }"
                    class="kebab"
                  >
                    <div v-click-outside="closeDropdownActions" class="dropdown-actions">
                      <div class="atom-icon d-block mr-0" @click="openKebab(item)">
                        <img src="@/assets/icons/menu/ico-kebab.svg" />
                      </div>
                      <div
                        v-if="openedItem.userId === item.userId"
                        v-click-outside="closeKebabConf"
                        class="dropdown-actions__wrapper"
                      >
                        <div class="dropdown-actions__inner">
                          <div class="dropdown-actions__item d-flex align-items-center" @click="openUserDetail(item)">
                            <div class="atom-icon">
                              <img src="@/assets/icons/admin/ico-ico-zakaznik.svg" />
                            </div>
                            {{ $t("informaceOUzivateli") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="usersWithProjects.length > 0"
        class="custom-table__footer d-flex align-items-center justify-content-between"
      >
        <div class="custom-table__footer__actions align-items-center" />

        <Paging
          :page="{
            currentPage: page,
            rowsPerPage: rowsPerPage,
            itemsTotalCount: usersWithProjects.length,
            itemsCount: usersWithProjects.length
          }"
          @page="page = $event"
          @next-page="page++"
          @prev-page="page--"
          @rows-per-page="rowsPerPage = $event"
        />
      </div>
    </div>
    <div v-if="openedDetail.length > 0">
      <UsersDetail
        :opened="openedDetail"
        :user="selectedUser"
        @close-box="toggleDetailModal"
        @open-box="toggleDetailModal"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import Paging from "@/components/paging/paging.vue"
import UsersDetail from "@/components/modals/admin/customer/user.vue"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    Paging,
    UsersDetail
  },
  props: {
    project: Object
  },
  setup() {
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()

    return { projectStore, customerStore }
  },
  data() {
    return {
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      rowsPerPage: 20,
      isActionsDropdownVisible: false,
      page: 0,
      loading: false,
      selectedUser: {},
      openedAppend: [],
      openedRemove: [],
      customerUsers: [],
      openedNewUser: [],
      openedDeleteUser: false,
      deleteText: "",
      errorsToTranslate: [],
      openedError: false,
      showModalDeleteSingleUser: false,
      modalOpenedDeleteUser: false,
      usersToDelete: [],
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false,
      openedInfoConfirmation: false,
      sort: "userId",
      sortType: "asc",
      search: "",
      columns: [
        {
          type: "userId",
          name: "userId",
          sortable: true,
          sortBy: "userId",
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "firstName",
          name: "firstName",
          sortable: true,
          sortBy: "firstName",
          visible: true,
          order: 2,
          minWidth: "50px"
        },
        {
          type: "lastName",
          name: "lastName",
          sortable: true,
          sortBy: "lastName",
          visible: true,
          order: 3,
          minWidth: "50px"
        },
        {
          type: "phone",
          name: "phone",
          sortable: true,
          sortBy: "phone",
          visible: true,
          order: 4,
          minWidth: "170px"
        },
        {
          type: "email",
          name: "email",
          sortable: true,
          sortBy: "email",
          visible: true,
          order: 5,
          minWidth: "250px"
        },
        {
          type: "projects",
          name: "projects",
          sortBy: "projects",
          sortable: false,
          visible: true,
          order: 6,
          minWidth: "50px"
        },
        {
          type: "role",
          name: "role",
          sortable: true,
          sortBy: "role",
          visible: true,
          order: 7,
          minWidth: "160px"
        }
      ],
      tableColumnsDefault: {
        userId: {
          show: true,
          order: 1,
          title: "userId"
        },
        firstName: {
          show: true,
          order: 2,
          title: "firstName"
        },
        lastName: {
          show: true,
          order: 3,
          title: "lastName"
        },
        phone: {
          show: true,
          order: 4,
          title: "phone"
        },
        email: {
          show: true,
          order: 5,
          title: "email"
        }
      },
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      users: [],
      projectUsers: [],
      openedItem: {},
      selectedRows: [],
      usersWithProjects: [],
      openedDetail: []
    }
  },
  computed: {
    storedProject() {
      return this.projectStore.selectedProject
    },
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    customer() {
      return this.customerStore.selectedCustomer
    },
    projects() {
      return this.projectStore.projectList
    },
    customersProjects() {
      if (this.projects.filter((p) => p.customerId === this.customer.customerId).length > 0) {
        return this.projects.filter((p) => p.customerId === this.customer.customerId)
      } else {
        return []
      }
    },
    filteredUserList() {
      return this.usersWithProjects.filter((user) =>
        Object.values(user).some((val) =>
          typeof val === "string" ? val.toLowerCase().includes(this.search.toLowerCase()) : false
        )
      )
    }
  },
  watch: {
    projectUsers() {
      this.loadUsersWithProjects()
    },
    filteredUserList() {
      this.updateResponsiveTable()
    }
  },
  mounted() {
    if (this.storedProject) {
      if (this.storedProject.projectId !== this.projectId) {
        this.projectStore.setProjectById(this.projectId)
      }
      this.loadUsers()
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })
  },
  methods: {
    sortBy(sortBy) {
      let sorted
      this.isSelectedAllOnPage = false
      this.sort = sortBy
      if (this.sortType === "asc") {
        sorted = _.orderBy(this.usersWithProjects, `${sortBy}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.usersWithProjects, `${sortBy}`, "asc")
        this.sortType = "asc"
      }
      this.dateChanged = false
      this.usersWithProjects = sorted
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    middlewareKebab(event) {
      return event.target.className !== "custom-control-label"
    },
    openKebab(user) {
      this.openedItem = this.openedItem === user ? {} : user
    },
    closeKebab() {
      this.openedItem = {}
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "users")
    },
    toggleDetailModal(box) {
      if (this.openedDetail.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedDetail = []
          this.selectedRows = []
          this.loadUsers()
        } else {
          this.openedDetail.splice(this.openedDetail.indexOf(box), 1)
        }
      } else {
        this.openedDetail.push(box)
      }
    },
    loadUsers() {
      this.users = []
      this.projectUsers = []

      axios
        .get(process.env.VUE_APP_API + "/users?limit=1&customerId[eq]=" + this.storedProject.customerId)
        .then((result) => {
          let query
          let steps = Math.ceil(result.data.metadata.count / 200)
          let promises = []
          for (let i = 0; i < steps; i++) {
            query = "/users?customerId[eq]=" + this.storedProject.customerId + "&offset=" + i * 200 + "&limit=200"

            promises.push(
              axios
                .get(process.env.VUE_APP_API + query)
                .then((result) => {
                  result.data.data.forEach((user) => {
                    let isIotAdmin = false

                    user.privileges.forEach((privilege) => {
                      if (
                        privilege.privilege === "IoTAdmin" &&
                        privilege.customerId === this.storedCustomer.customerId
                      ) {
                        isIotAdmin = true
                      }
                    })
                    if (
                      user.privileges.some(
                        ({ privilege, customerId }) =>
                          privilege === "CustomerAdmin" && customerId === this.storedCustomer.customerId
                      )
                    ) {
                      user.notSelectable = true
                    }

                    if (isIotAdmin === false) {
                      this.projectUsers = this.projectUsers.concat(user)
                    }
                  })
                })
                .catch(() => {})
            )
          }
          return Promise.all(promises).then(() => {
            this.$nextTick(() => {
              this.updateResponsiveTable()
            })
            return true
          })
        })
    },
    loadUsersWithProjects() {
      let users = []
      this.usersWithProjects = []
      this.projectUsers.forEach((user) => {
        let obj = structuredClone(user)
        obj.projects = []
        let isIotAdmin = false

        user.privileges.forEach((privilege) => {
          if (privilege.privilege === "IoTAdmin" && privilege.customerId === this.storedCustomer.customerId) {
            isIotAdmin = true
          }
        })

        if (
          user.privileges.some(
            ({ privilege, customerId, projectId }) =>
              privilege === "ProjectAdmin" &&
              projectId === this.storedProject.projectId &&
              customerId === this.storedCustomer.customerId
          )
        ) {
          user.privileges.forEach((privilege) => {
            if (
              privilege.privilege === "ProjectAdmin" &&
              privilege.projectId !== "." &&
              privilege.customerId === this.storedCustomer.customerId &&
              isIotAdmin === false
            ) {
              obj.projects.push(privilege.projectId)
              obj.role = "ProjectAdminRole"
            }
          })
        }

        if (
          user.privileges.some(
            ({ privilege, customerId }) => privilege === "ProjectAdmin" && customerId === this.storedCustomer.customerId
          )
        ) {
          obj.role = "ProjectAdminRole"
        }

        // customerAdmin has all projects
        if (
          user.privileges.some(
            ({ privilege, customerId }) =>
              privilege === "CustomerAdmin" && customerId === this.storedCustomer.customerId
          )
        ) {
          obj.projects = []
          obj.projects.push("AllProjects")
          obj.role = "CustomerAdminRole"
        }
        if (obj.projects.length) users.push(obj)
      })
      this.usersWithProjects = users
      this.$nextTick(() => {
        this.updateResponsiveTable()
      })
    },
    openUserDetail(item) {
      this.selectedUser = item
      this.openedDetail.push("userDetail")
    },
    setRows(rows) {
      this.selectedRows = rows
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>

<style lang="scss" scoped></style>
